import React from "react";

function Footer() {
  return (
    <div className="footer-container">
      <footer className="py-1 footer">
        <div className="container">
          <p className="m-0 text-center text-white">
            &copy; University of Helsinki 2022
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;